












import { Component , Vue , Emit } from 'vue-property-decorator';
@Component
export default class yzqModal extends Vue {
    modal:Boolean = false
    @Emit('whatYzq') send(modal:Boolean){}
    // 跳转到购物车页面
    closeModal() {
        this.send(this.modal);
    }
} 
